import { Action, Dispatch } from "redux";
import { Environments, GetHealthCheckDetails } from "@emisgroup/cohort-builder-kit";
import { ProgressSpinnerSlice } from "../../../../ProgressSpinner/Index";
import { OutputConfigSlice } from "../../redux";
import { handleException } from "../../../../../ErrorMessages/helper";

/**
 * To fetch the final output list
 */
export const FetchFinalOutputList = async (
  dispatch: Dispatch<Action>,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function,
  configId: string,
  env: Environments,
  accessToken: string
): Promise<void> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.FinalOutputList")));
    const res = await GetHealthCheckDetails(configId, env, accessToken);
    if (res && res["data"]) {
      const { outputElements } = res?.["data"]?.["payload"] || {};
      dispatch(OutputConfigSlice.actions.setFinalOutputList(outputElements));
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    }
  } catch (ex) {
    handleException(ex, dispatch, "GetMappedStatusErrMsg");
  }
};
